module.exports = __webpack_public_path__ + "static/media/canada4.e0b23508.jpg";